module.exports = require("./ff-Latn.js");